import type { FILES_EXPORT_FORMATS } from '../../config/fileTypes.ts';
import { cfetchWithAbort } from '../../utils/cfetchWithAbort.ts';

import type { AuthData } from './GoogleAuth.ts';

type Headers = {
	Authorization: string;
	'X-Goog-Drive-Resource-Keys'?: string;
};

/**
 * The class is responsible for interaction with Google Drive API:
 * https://developers.google.com/drive/api/v3/reference
 */
export class GoogleDrive {
	private credentials: AuthData;

	static GOOGLE_API_URL = 'https://www.googleapis.com/drive/v3';

	constructor(credentials: AuthData) {
		this.credentials = credentials;
	}

	/** Performs export of a Google Docs files to other formats
	 * https://developers.google.com/drive/api/v3/reference/files/export
	 */
	async exportFile(
		fileId: string,
		exportFormat: FILES_EXPORT_FORMATS,
		signal: AbortSignal,
	): Promise<Blob> {
		const path = `${GoogleDrive.GOOGLE_API_URL}/files/${fileId}/export`;
		const url = `${path}?mimeType=${exportFormat}&key=${this.credentials.apiKey}`;
		const headers: Headers = {
			Authorization: `Bearer ${this.credentials.oauthToken}`,
		};

		//https://jira.atlassian.com/browse/CONFCLOUD-75614
		//omit credentials to prevent CORS errors from google
		const request = new Request(url, {
			credentials: 'omit',
		});

		// We send a plain fetch instead of gapi.client usage because gapi.client seems to return data in a wrong format
		const res = await cfetchWithAbort(request, {
			headers,
			signal,
		});

		return res.blob();
	}
}
